module.exports = __webpack_public_path__ + "1bd96c22bc9144a5c4f68671aeca7276.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/netzbuehne01.jpg
// module id = 669
// module chunks = 0